import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface LockStoreState {
  isLocked: boolean;
  lastActivity: number;
  setLocked: (locked: boolean) => void;
  updateLastActivity: () => void;
}

export const useLockStore = create<LockStoreState>()(
  devtools(
    persist(
      (set) => ({
        isLocked: false,
        lastActivity: Date.now(),
        setLocked: (isLocked: boolean) =>
          set(() => ({ isLocked }), undefined, 'lock/setLocked'),
        updateLastActivity: () =>
          set(
            () => ({ lastActivity: Date.now() }),
            undefined,
            'lock/updateLastActivity'
          ),
      }),
      {
        name: 'lock-store',
        partialize: (state) => ({ isLocked: state.isLocked }),
      }
    ),
    { name: 'lock-store' }
  )
);
